import React from 'react';
import ReactInputMask from 'react-input-mask';

const getErrorMessage = (errors: any, inputName: string, index: number) => {
  const keys = inputName.split('.');
  let currentError = errors;

  for (const key of keys) {
    if (Array.isArray(currentError)) {
      currentError = currentError[index];
    }
    if (currentError && currentError[key]) {
      currentError = currentError[key];
    } else {
      return null;
    }
  }

  return currentError.message;
};

interface ICartInput {
  id?: string;
  inputName?: string;
  label?: string;
  type?: string;
  errors?: any;
  register?: any;
  validationSchema?: any;
  placeholder?: string;
  index?: number;
  defaultValue?: string;
  mask?: string | (string | RegExp)[];
  isTextArea?: boolean;
  as?: React.ElementType;
  icon?: React.ReactNode;
  isDisabled?: boolean;
}

export const CartInput = React.forwardRef<HTMLInputElement, ICartInput>(
  (
    {
      id = '',
      inputName = '',
      label = '',
      type = 'text',
      errors = {},
      register = () => {},
      validationSchema = {},
      placeholder = '',
      index = 0,
      defaultValue = '',
      mask = '',
      isTextArea = false,
      as: InputComponent,
      icon,
      isDisabled = false,
      ...props
    }: ICartInput,
    ref
  ) => {
    const errorMessage = getErrorMessage(errors, inputName, index);
    const baseInputClass = `w-full px-4 py-3.5 rounded-xl border font-medium text-sm transition-all ${
      errorMessage
        ? 'border-red-500 focus:border-red-500 focus:ring-4 focus:ring-red-100'
        : 'border-gray-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100'
    } ${
      isDisabled
        ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
        : 'bg-white text-gray-900'
    } placeholder-gray-400 outline-none`;

    const InputElement = mask ? ReactInputMask : InputComponent || 'input';

    return (
      <div className="w-full">
        <div className="flex justify-between items-center mb-2.5">
          <label htmlFor={id} className="text-sm font-medium text-gray-600">
            {label}
          </label>
          {errorMessage && (
            <span className="text-sm font-medium text-red-600">
              {errorMessage}
            </span>
          )}
        </div>
        <div className="relative">
          <InputElement
            ref={ref}
            {...props}
            id={id}
            name={inputName}
            type={type}
            defaultValue={defaultValue}
            placeholder={placeholder}
            className={baseInputClass}
            disabled={isDisabled}
            {...register(inputName, validationSchema)}
            mask={mask}
          />
          {icon && (
            <span className="absolute right-4 top-1/2 -translate-y-1/2">
              {icon}
            </span>
          )}
        </div>
      </div>
    );
  }
);
